const KPI_CARDS = [
  {
    icon: 'play_circle',
    label: 'Video Completion Rate (VCR)',
    value: '64.2%',
    delta: '+12.4%',
  },
  {
    icon: 'qr_code_2',
    label: 'QR Scans',
    value: '1,240',
    delta: '+5.2%',
  },
  {
    icon: 'data_thresholding',
    label: 'First-Quartile Drop-Off',
    value: '12.8%',
    delta: '+18.1%',
  },
];

const CAMPAIGN_ROWS = [
  { name: 'Summer Glow Launch', status: 'Active', qr: '850', vcr: '75.3%' },
  { name: 'Holiday Omni-Channel', status: 'Scheduled', qr: '620', vcr: '61.2%' },
  { name: 'Skincare Refresh', status: 'Active', qr: '1,140', vcr: '82.5%' },
];

const LEADERBOARD = [
  { rank: 1, name: 'Golden Hour Serum', scans: '980', pct: 95 },
  { rank: 2, name: 'Summer Dew Mist', scans: '745', pct: 78 },
  { rank: 3, name: 'Night Repair Elixir', scans: '610', pct: 65 },
];

const AI_INSIGHTS = [
  {
    metric: 'QR Scans',
    body: 'The Social eComm template is the best performing creative to drive action — up to 2× better than others.',
    cta: 'Build this Creative',
  },
  {
    metric: 'VCR',
    body: 'The Social to CTV template is the best performing to drive engagement — up to 20% better VCR.',
    cta: 'Build this Creative',
  },
];

const RANK_STYLES = [
  'aspectly:bg-primary aspectly:text-white',
  'aspectly:bg-primary-container aspectly:text-primary',
  'aspectly:bg-surface-container-high aspectly:text-on-surface-variant',
];

const STATUS_PILL: Record<string, string> = {
  Active: 'aspectly:bg-primary/10 aspectly:text-primary',
  Scheduled: 'aspectly:bg-on-surface-variant/10 aspectly:text-on-surface-variant',
};

export default function AnalyticsPage() {
  return (
    <div className="aspectly:p-4 aspectly:md:p-8 aspectly:lg:p-12 aspectly:space-y-10">
      {/* Page header */}
      <div className="aspectly:flex aspectly:items-end aspectly:justify-between aspectly:gap-6 aspectly:flex-wrap">
        <div>
          <h1 className="aspectly:text-4xl aspectly:font-black aspectly:font-headline aspectly:text-on-surface aspectly:tracking-tight">
            Performance Analytics
          </h1>
          <p className="aspectly:text-on-surface-variant aspectly:mt-1 aspectly:font-bold">
            Real-time cross-channel creative intelligence
          </p>
        </div>
        <div className="aspectly:flex aspectly:space-x-2">
          <button className="aspectly:px-4 aspectly:py-2 aspectly:bg-surface-container-low aspectly:text-on-surface-variant aspectly:rounded-xl aspectly:text-sm aspectly:font-black aspectly:hover:bg-surface-container-high aspectly:transition-colors aspectly:cursor-pointer">
            Last 30 Days
          </button>
          <button className="aspectly:px-4 aspectly:py-2 aspectly:bg-primary aspectly:text-on-primary aspectly:rounded-xl aspectly:text-sm aspectly:font-black aspectly:shadow-xs aspectly:hover:bg-primary-dim aspectly:transition-all aspectly:flex aspectly:items-center aspectly:space-x-2 aspectly:cursor-pointer">
            <span className="material-symbols-outlined aspectly:text-sm">download</span>
            <span>Export Report</span>
          </button>
        </div>
      </div>

      {/* KPI Cards */}
      <section className="aspectly:grid aspectly:grid-cols-1 aspectly:md:grid-cols-3 aspectly:gap-6">
        {KPI_CARDS.map((card) => (
          <div
            key={card.label}
            className="aspectly:bg-surface-container-lowest aspectly:p-6 aspectly:rounded-2xl aspectly:border aspectly:border-outline-variant/10 aspectly:shadow-xs aspectly:flex aspectly:flex-col aspectly:justify-between"
          >
            <div className="aspectly:flex aspectly:justify-between aspectly:items-start">
              <span className="aspectly:p-2 aspectly:bg-primary-container aspectly:text-primary aspectly:rounded-lg">
                <span className="material-symbols-outlined">{card.icon}</span>
              </span>
              <span className="aspectly:text-primary aspectly:font-black aspectly:text-xs">{card.delta}</span>
            </div>
            <div className="aspectly:mt-4">
              <p className="aspectly:text-xs aspectly:text-on-surface-variant aspectly:font-black aspectly:uppercase aspectly:tracking-wider">
                {card.label}
              </p>
              <p className="aspectly:text-3xl aspectly:font-headline aspectly:font-black aspectly:text-on-surface">{card.value}</p>
            </div>
          </div>
        ))}
      </section>

      {/* Main grid: performance table + AI insights | leaderboard */}
      <div className="aspectly:grid aspectly:grid-cols-1 aspectly:lg:grid-cols-3 aspectly:gap-8">
        {/* Left column (2/3) */}
        <div className="aspectly:lg:col-span-2 aspectly:space-y-6">
          {/* Campaign performance table */}
          <div className="aspectly:bg-surface-container-lowest aspectly:rounded-2xl aspectly:shadow-xs aspectly:overflow-hidden aspectly:border aspectly:border-outline-variant/10">
            <div className="aspectly:px-6 aspectly:py-4 aspectly:bg-surface-container-low aspectly:border-b aspectly:border-outline-variant/10 aspectly:flex aspectly:justify-between aspectly:items-center">
              <h3 className="aspectly:font-headline aspectly:font-black aspectly:text-on-surface">Campaign Performance</h3>
              <button className="aspectly:text-primary aspectly:text-xs aspectly:font-black aspectly:uppercase aspectly:tracking-wider aspectly:cursor-pointer aspectly:hover:underline">
                View All
              </button>
            </div>
            <div className="aspectly:overflow-x-auto">
              <table className="aspectly:w-full aspectly:text-left aspectly:border-collapse">
                <thead className="aspectly:bg-surface-container-low/50">
                  <tr>
                    {['Campaign', 'Status', 'QR Scans', 'VCR'].map((h) => (
                      <th
                        key={h}
                        className="aspectly:px-6 aspectly:py-3 aspectly:text-[10px] aspectly:font-black aspectly:text-on-surface-variant aspectly:uppercase aspectly:tracking-widest"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="aspectly:divide-y aspectly:divide-outline-variant/10">
                  {CAMPAIGN_ROWS.map((row) => (
                    <tr key={row.name} className="aspectly:hover:bg-primary-container/30 aspectly:transition-colors">
                      <td className="aspectly:px-6 aspectly:py-4 aspectly:font-bold aspectly:text-sm">{row.name}</td>
                      <td className="aspectly:px-6 aspectly:py-4">
                        <span
                          className={`aspectly:px-2 aspectly:py-1 aspectly:text-[10px] aspectly:font-black aspectly:rounded-full aspectly:uppercase ${STATUS_PILL[row.status]}`}
                        >
                          {row.status}
                        </span>
                      </td>
                      <td className="aspectly:px-6 aspectly:py-4 aspectly:text-sm aspectly:font-bold">{row.qr}</td>
                      <td className="aspectly:px-6 aspectly:py-4 aspectly:text-sm aspectly:font-black aspectly:text-primary">{row.vcr}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* AI Insights */}
          <div className="aspectly:bg-primary aspectly:rounded-2xl aspectly:p-8 aspectly:relative aspectly:overflow-hidden aspectly:shadow-xl aspectly:text-on-primary">
            <div className="aspectly:relative aspectly:z-10 aspectly:space-y-4">
              <div className="aspectly:flex aspectly:items-center aspectly:space-x-2">
                <span className="material-symbols-outlined">auto_awesome</span>
                <h3 className="aspectly:font-headline aspectly:font-black aspectly:text-lg">AI Optimisation Insights</h3>
              </div>
              <div className="aspectly:grid aspectly:grid-cols-1 aspectly:md:grid-cols-2 aspectly:gap-4">
                {AI_INSIGHTS.map((insight) => (
                  <div
                    key={insight.metric}
                    className="aspectly:bg-white/10 aspectly:backdrop-blur-md aspectly:p-4 aspectly:rounded-xl aspectly:border aspectly:border-white/20 aspectly:flex aspectly:flex-col"
                  >
                    <p className="aspectly:text-[10px] aspectly:font-black aspectly:uppercase aspectly:tracking-tighter aspectly:text-primary-fixed aspectly:mb-1">
                      {insight.metric}
                    </p>
                    <p className="aspectly:text-sm aspectly:font-medium aspectly:leading-relaxed aspectly:grow">{insight.body}</p>
                    <button className="aspectly:mt-4 aspectly:w-full aspectly:bg-white aspectly:text-primary aspectly:py-2 aspectly:rounded-lg aspectly:font-black aspectly:text-sm aspectly:hover:bg-primary-container aspectly:transition-all aspectly:cursor-pointer">
                      {insight.cta}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Right column (1/3) — Creative Leaderboard */}
        <div className="aspectly:flex aspectly:flex-col aspectly:h-full">
          <div className="aspectly:bg-surface-container-lowest aspectly:rounded-2xl aspectly:shadow-xs aspectly:p-6 aspectly:grow aspectly:flex aspectly:flex-col aspectly:border aspectly:border-outline-variant/10">
            <h3 className="aspectly:font-headline aspectly:font-black aspectly:text-on-surface aspectly:mb-6 aspectly:flex aspectly:items-center aspectly:space-x-2">
              <span className="material-symbols-outlined aspectly:text-primary">military_tech</span>
              <span>Creative Leaderboard</span>
            </h3>
            <div className="aspectly:space-y-6 aspectly:grow">
              {LEADERBOARD.map((item, idx) => (
                <div key={item.name} className="aspectly:flex aspectly:items-center aspectly:space-x-4">
                  <div className="aspectly:relative aspectly:shrink-0">
                    <div className="aspectly:w-16 aspectly:h-16 aspectly:rounded-xl aspectly:bg-linear-to-br aspectly:from-primary-container aspectly:to-surface-container-low aspectly:flex aspectly:items-center aspectly:justify-center">
                      <span className="material-symbols-outlined aspectly:text-primary/40 aspectly:text-2xl">
                        image
                      </span>
                    </div>
                    <div
                      className={`aspectly:absolute aspectly:-top-2 aspectly:-left-2 aspectly:w-6 aspectly:h-6 aspectly:text-[10px] aspectly:font-black aspectly:rounded-full aspectly:flex aspectly:items-center aspectly:justify-center ${RANK_STYLES[idx]}`}
                    >
                      {item.rank}
                    </div>
                  </div>
                  <div className="aspectly:flex-1 aspectly:min-w-0">
                    <p className="aspectly:text-sm aspectly:font-black aspectly:text-on-surface aspectly:truncate">{item.name}</p>
                    <p className="aspectly:text-[10px] aspectly:font-bold aspectly:text-on-surface-variant">
                      {item.scans} QR Scans
                    </p>
                    <div className="aspectly:w-full aspectly:bg-surface-container-high aspectly:h-1.5 aspectly:rounded-full aspectly:mt-2 aspectly:overflow-hidden">
                      <div
                        className="aspectly:bg-primary aspectly:h-full aspectly:rounded-full"
                        style={{ width: `${item.pct}%` }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
